import React from "react";
import { GoHome } from "react-icons/go";
import { MdOutlineNavigateNext } from "react-icons/md";
import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";

const BreadcrumbSection = ({
  from,
  location,
  categoryName,
  categoryIcon,
  categoryTitle,
}) => {
  return (
    <div className="breadcrumb_section">
      {from === "alongRoute" ? (
        <Breadcrumb className="breadcrumb">
          <BreadcrumbItem>
            <Link to="/" className="breadcrumb_item1">
              <GoHome />
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to="/my-routes" className="breadcrumb_item1">
              My Routes
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link
              to="/along-route"
              state={{ data: location?.state?.data }}
              className="breadcrumb_item1"
            >
              Along Route
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem active className="breadcrumb_item2">
            Details
          </BreadcrumbItem>
        </Breadcrumb>
      ) : from === "addMorePointToRoute" ? (
        <Breadcrumb className="breadcrumb">
          <BreadcrumbItem>
            <Link to="/" className="breadcrumb_item1">
              <GoHome />
            </Link>
            <span className="breadcrumb-divider">
              <MdOutlineNavigateNext />
            </span>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to="/my-routes" className="breadcrumb_item1">
              My Routes
            </Link>
            <span className="breadcrumb-divider">
              <MdOutlineNavigateNext />
            </span>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link
              to="/add-more-points-to-route"
              state={{ data: location?.state?.data }}
              className="breadcrumb_item1"
            >
              Add more credits to route
            </Link>
            <span className="breadcrumb-divider">
              <MdOutlineNavigateNext />
            </span>
          </BreadcrumbItem>
          <BreadcrumbItem active className="breadcrumb_item2">
            Details
          </BreadcrumbItem>
        </Breadcrumb>
      ) : from === "topPlaces" ? (
        <Breadcrumb className="breadcrumb">
          <BreadcrumbItem>
            <Link to="/" className="breadcrumb_item1">
              <GoHome />
            </Link>
            <span className="breadcrumb-divider">
              <MdOutlineNavigateNext />
            </span>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to="/" className="breadcrumb_item1">
              Top Places
            </Link>
            <span className="breadcrumb-divider">
              <MdOutlineNavigateNext />
            </span>
          </BreadcrumbItem>
          <BreadcrumbItem active className="breadcrumb_item2">
            Details
          </BreadcrumbItem>
        </Breadcrumb>
      ) : from === "customAddress" ? (
        <Breadcrumb className="breadcrumb">
          <BreadcrumbItem>
            <Link to="/" className="breadcrumb_item1">
              <GoHome />
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to="/my-routes" className="breadcrumb_item1">
              My Routes
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link
              to="/search-custom-point"
              state={{ data: location?.state?.data }}
              className="breadcrumb_item1"
            >
              Custom Address
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem active className="breadcrumb_item2">
            Details
          </BreadcrumbItem>
        </Breadcrumb>
      ) : from === "exploreNearMe" ? (
        <Breadcrumb className="breadcrumb">
          <BreadcrumbItem>
            <Link to="/" className="breadcrumb_item1">
              <GoHome />
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to="/explore-near-me" className="breadcrumb_item1">
              Explore Near Me
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem active className="breadcrumb_item2">
            Details
          </BreadcrumbItem>
        </Breadcrumb>
      ) : from === "routeDetail" ? (
        <Breadcrumb className="breadcrumb">
          <BreadcrumbItem>
            <Link to="/" className="breadcrumb_item1">
              <GoHome />
            </Link>
            <span className="breadcrumb-divider">
              <MdOutlineNavigateNext />
            </span>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to="/my-routes" className="breadcrumb_item1">
              My Routes
            </Link>
            <span className="breadcrumb-divider">
              <MdOutlineNavigateNext />
            </span>
          </BreadcrumbItem>
          <BreadcrumbItem active className="breadcrumb_item2">
            Details
          </BreadcrumbItem>
        </Breadcrumb>
      ) : from === "alongPreviousPoint" ? (
        <Breadcrumb className="breadcrumb">
          <BreadcrumbItem>
            <Link to="/" className="breadcrumb_item1">
              <GoHome />
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to="/my-routes" className="breadcrumb_item1">
              My Routes
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link
              to="/along-route-previous-point"
              state={{
                from: "alongPreviousPoint",
                data: location?.state?.data,
              }}
              className="breadcrumb_item1"
            >
              Along Route from Point{" "}
              <span className="pointName">
                {location?.state?.data[1]?.place?.title}
              </span>{" "}
              and Point{" "}
              <span className="pointName">
                {location?.state?.data[0]?.place?.title}
              </span>
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem active className="breadcrumb_item2">
            Details
          </BreadcrumbItem>
        </Breadcrumb>
      ) : from === "favourite" ? (
        <Breadcrumb className="breadcrumb">
          <BreadcrumbItem>
            <Link to="/" className="breadcrumb_item1">
              <GoHome />
            </Link>
            <span className="breadcrumb-divider">
              <MdOutlineNavigateNext />
            </span>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to="/favourites" className="breadcrumb_item1">
              Favourites
            </Link>
            <span className="breadcrumb-divider">
              <MdOutlineNavigateNext />
            </span>
          </BreadcrumbItem>
          <BreadcrumbItem active className="breadcrumb_item2">
            Details
          </BreadcrumbItem>
        </Breadcrumb>
      ) : from === "routeDetailExploreNearBy" ? (
        <Breadcrumb className="breadcrumb">
          <BreadcrumbItem>
            <Link to="/" className="breadcrumb_item1">
              <GoHome />
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to="/my-routes" className="breadcrumb_item1">
              My Routes
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem active className="breadcrumb_item2">
            Details
          </BreadcrumbItem>
        </Breadcrumb>
      ) : from === "searchEverywhere" ? (
        <Breadcrumb className="breadcrumb">
          <BreadcrumbItem>
            <Link to="/" className="breadcrumb_item1">
              <GoHome />
            </Link>
            <span className="breadcrumb-divider">
              <MdOutlineNavigateNext />
            </span>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link
              to="/search-everywhere"
              state={{
                data: location?.state?.data,
                key: location?.state?.key,
              }}
              className="breadcrumb_item1"
            >
              Categories
            </Link>
            <span className="breadcrumb-divider">
              <MdOutlineNavigateNext />
            </span>
          </BreadcrumbItem>
          <BreadcrumbItem active className="breadcrumb_item2">
            Details
          </BreadcrumbItem>
        </Breadcrumb>
      ) : (
        <Breadcrumb className="breadcrumb">
          <BreadcrumbItem>
            <Link to="/" className="breadcrumb_item1">
              <GoHome className="home_icon" />
            </Link>
            <span className="breadcrumb-divider">
              <MdOutlineNavigateNext />
            </span>
          </BreadcrumbItem>

          <BreadcrumbItem>
            <Link to="/" className="breadcrumb_item1">
              Category
            </Link>
            <span className="breadcrumb-divider">
              <MdOutlineNavigateNext />
            </span>
          </BreadcrumbItem>

          <BreadcrumbItem>
            <Link
              to="/category-list"
              className="breadcrumb_item1"
              state={{
                categoryName,
                categoryTitle,
                categoryIcon,
              }}
            >
              {categoryName}
            </Link>
            <span className="breadcrumb-divider">
              <MdOutlineNavigateNext />
            </span>
          </BreadcrumbItem>

          <BreadcrumbItem active className="breadcrumb_item2">
            Details
          </BreadcrumbItem>
        </Breadcrumb>
      )}
    </div>
  );
};

export default BreadcrumbSection;
